import React, { useEffect, useState } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import './Layout.css';
import Footer from './Footer';

const navigationItems = [
  { to: '/', label: 'Home' },
  { to: '/about', label: 'About Us' },
  { to: '/publicdisclosure', label: 'Public Disclosure' },
  { to: '/facility', label: 'Facilities' },
  { to: '/gallery', label: 'Gallery' },
  { to: '/contact', label: 'Contact' }
];

const Layout = ({ children }) => {
  const [isNavVisible, setIsNavVisible] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    setIsNavVisible(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [location.pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 18);
    };

    handleScroll();
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    document.body.style.overflow = isNavVisible ? 'hidden' : '';

    return () => {
      document.body.style.overflow = '';
    };
  }, [isNavVisible]);

  return (
    <>
      <header className={`site-header ${isScrolled ? 'site-header--scrolled' : ''}`}>
        <nav className="site-nav" aria-label="Primary navigation">
          <Link className="site-brand" to="/">
            <span className="site-brand__mark">
              <img className="logo" src="/external/images/logo1.png" alt="Maxfort Education logo" />
            </span>
            <span className="site-brand__copy">
              <strong>Maxfort Education</strong>
              <small>Partapur, Rajasthan</small>
            </span>
          </Link>

          <div className="site-nav__desktop">
            <div className="site-nav__links">
              {navigationItems.map((item) => (
                <NavLink
                  key={item.to}
                  to={item.to}
                  end={item.to === '/'}
                  className={({ isActive }) => `site-nav__link ${isActive ? 'is-active' : ''}`}
                >
                  {item.label}
                </NavLink>
              ))}
            </div>

            <a className="site-nav__cta" href="tel:+919928620516">
              <span>Admissions</span>
              <strong>+91 99286 20516</strong>
            </a>
          </div>

          <button
            className={`nav-toggle ${isNavVisible ? 'is-open' : ''}`}
            type="button"
            aria-label={isNavVisible ? 'Close menu' : 'Open menu'}
            aria-expanded={isNavVisible}
            onClick={() => setIsNavVisible((current) => !current)}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </nav>
      </header>

      <button
        className={`nav-overlay ${isNavVisible ? 'is-open' : ''}`}
        type="button"
        aria-label="Close navigation menu"
        onClick={() => setIsNavVisible(false)}
      ></button>

      <aside className={`nav-drawer ${isNavVisible ? 'is-open' : ''}`} aria-hidden={!isNavVisible}>
        <div className="nav-drawer__top">
          <div className="nav-drawer__brand">
            <strong>Maxfort Education</strong>
            <small>Learning with purpose</small>
          </div>
          <button
            className="nav-drawer__close"
            type="button"
            aria-label="Close menu"
            onClick={() => setIsNavVisible(false)}
          >
            <span></span>
            <span></span>
          </button>
        </div>

        <div className="nav-drawer__links">
          {navigationItems.map((item) => (
            <NavLink
              key={item.to}
              to={item.to}
              end={item.to === '/'}
              className={({ isActive }) => `nav-drawer__link ${isActive ? 'is-active' : ''}`}
            >
              {item.label}
            </NavLink>
          ))}
        </div>

        <div className="nav-drawer__panel">
          <p>Visit the campus and see the learning environment in person.</p>
          <a href="tel:+919928620516">Call admissions</a>
        </div>
      </aside>

      <main className="site-main">{children}</main>
      <Footer />
    </>
  );
};

export default Layout;
